import './Register.scss';
import RegisterState, { RegisterPageProps, RegisterSteps } from "./Register.models";
import RegisterImage from '../../../assest/images/cropped-Logotype.png';
import StudentFieldService from "../../../services/education/StudentFieldService";
import StudentBaseService from "../../../services/education/StudentBaseService";
import AuthenticationService from "../../../services/identity/AuthenticationService";
import SelectInput from "../../shared/select/SelectInput";
import { PureComponent } from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import NotifyContext from '../../../contexts/NotifyContext';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';

export default class Register extends PureComponent<RegisterPageProps, RegisterState> {
    static contextType = NotifyContext

    studentFieldService: StudentFieldService;
    studentBaseService: StudentBaseService;
    authenticationService: AuthenticationService;

    constructor(props: any) {
        super(props);
        this.studentFieldService = new StudentFieldService();
        this.studentBaseService = new StudentBaseService();
        this.authenticationService = new AuthenticationService();
        this.state = { entity: { haveOTP: false }, userInformation: { haveOTP: false }, studentBases: [], studentFields: [], step: RegisterSteps.personalInformation, showNavigator: false };
    }

    componentDidMount() {
        let self = this;
        self.getBases();
        self.getFields();
        this.setState({ entity: { studentReferrerId: this.props.reffererId } })
    }

    getBases = () => {
        let self = this;

        self.studentBaseService.getTitleValues().then(function (response) {
            self.setState({ studentBases: response });
        });
    }

    getFields = () => {
        let self = this;

        self.studentFieldService.getTitleValues().then(function (response) {
            self.setState({ studentFields: response });
        });
    }

    showNotify = (description: string) => {
        let self = this;
        console.log(description)
        self.context.showNotify({ badge: "danger", title: "رخداد خطا", description: description });
    }

    getRegisterPage = () => {
        let self = this;

        if (self.state.entity?.phoneNumber == null || self.state.entity?.phoneNumber == "")
            self.showNotify('وارد کردن شماره همراه الزامی میباشد.');

        self.setState(() => {
            return { entity: { ...self.state.entity, haveOTP: true } }
        });

        self.authenticationService.registerStudent(self.state.entity).then(function (response) {
            if (!response) {
                self.showNotify('کد امنیتی وارد شده صحیح نمی باشد');
                return;
            }
            self.context.showNotify({ badge: "success", title: "برنده ساز", description: "به خانواده برنده ساز خوش آمدید , ثبت نام شما با موفقیت انجام شد, لطفا برای ورود کد ملی خود را وارد کنید" });
            self.setState({ showNavigator: true });
        });
    }


    validation = (step: RegisterSteps) => {
        let self = this;
        let entity = self.state.entity;

        if ((!entity.firstName || !entity.lastName) && (step === RegisterSteps.personalInformation || step === RegisterSteps.otpCode)) {
            this.showNotify('پر کردن تمامی فیلد ها اجباری می باشد');
            return false
        } else if (entity.phoneNumber?.length !== 11 && (step === RegisterSteps.systemInformation || step === RegisterSteps.otpCode)) {
            this.showNotify('لطفا شماره تماس را به درستی وارد کنید');
            return false
        } else if (entity.nationalCode?.length !== 10 && (step === RegisterSteps.systemInformation || step === RegisterSteps.otpCode)) {
            this.showNotify('لطفا کد ملی را به درستی وارد کنید');
            return false
        }
        else if ((!entity.studentBaseID || !entity.studentFieldID) && (step === RegisterSteps.gradeInformation || step === RegisterSteps.otpCode)) {
            this.showNotify('لطفا اطلاعات تحصیلی را به درستی وارد کنید');
            return false
        }

        return true
    }


    getOTPCode = () => {
        let self = this;

        this.setState((prevState) => {
            return {
                entity: {
                    ...prevState.entity,
                    studentReferrerId: self.props.reffererId ?? '', otp: '',
                },
            }
        })

        if (this.validation(RegisterSteps.otpCode))
            self.authenticationService.registerStudent(self.state.entity).then(function (response) {
                console.log('self.authenticationService', response)
                if (response === false) {
                    self.showNotify('شماره تماس یا کد ملی قبلا در سیستم ثبت شده است')
                    self.setState((prevState) => {
                        return { step: RegisterSteps.systemInformation }
                    });
                    return;
                }
                else {
                    self.setState((prevState) => {
                        return { entity: { ...prevState.entity, haveOTP: true }, step: RegisterSteps.otpCode }
                    });
                }
            }).catch((ex) => {
                console.log('cash authenticationService', ex)
                self.showNotify('شماره تماس یا کد ملی قبلا در سیستم ثبت شده است')
            });
    }

    setDate(value: any) {
        if (value !== null && value !== undefined)
            this.setState({
                birthDateValue: {
                    day: value.day,
                    month: value.month,
                    year: value.year,
                }
            })
    }

    onChangeBase = (value: any) => {
        this.setState((prevState) => {
            return { entity: { ...prevState.entity, studentBaseID: value } }
        })
    }

    onChangeField = (value: any) => {
        this.setState((prevState) => {
            return { entity: { ...prevState.entity, studentFieldID: value } }
        })
    }

    changeStep = (step: number) => {
        if (step !== -1 && !this.validation(this.state.step))
            return;


        if (this.state.step === RegisterSteps.systemInformation && step !== -1) {
            this.getOTPCode();
        }
        else if (this.state.step === RegisterSteps.personalInformation && step === -1)
            this.setState({ showNavigator: true })
        else
            this.setState({ step: this.state.step + step })
    }

    render(): React.ReactNode {
        let { entity, studentBases, studentFields, step } = this.state;
        let contentBody;
        let submitButton;



        switch (step) {
            case 0:
                contentBody = (<>
                    <label className='sub-title'>برای ثبت نام موقت اطلاعات خود را وارد کنید</label>

                    <input className="form-control" placeholder="نام" value={entity.firstName} onChange={e => this.setState((prevState) => {
                        return { entity: { ...prevState.entity, firstName: e.target.value } }
                    })}>
                    </input>
                    <input className="form-control" placeholder="نام خانوادگی" value={entity.lastName} onChange={e => this.setState((prevState) => {
                        return { entity: { ...prevState.entity, lastName: e.target.value } }
                    })}>
                    </input>

                </>);
                break;
            case 1:
                contentBody = <>
                    <label className='sub-title'>اطلاعات تحصیلی</label>
                    <SelectInput inputvalue={entity.studentBaseID} datas={studentBases} name="studentBase" value={this.onChangeBase} isNullAble={false} />
                    <SelectInput inputvalue={entity.studentFieldID} datas={studentFields} name="studentField" value={this.onChangeField} isNullAble={false} />
                </>;
                break;
            case 2:
                contentBody = <>
                    <label className='sub-title'>اطلاعات شناسایی</label>
                    <input className="form-control" inputMode="numeric" placeholder="شماره همراه " value={entity.phoneNumber} onChange={e => this.setState((prevState) => {
                        return { entity: { ...prevState.entity, phoneNumber: e.target.value } }
                    })}>
                    </input>
                    <input className="form-control" inputMode="numeric" placeholder="کد ملی" value={entity.nationalCode} onChange={e => this.setState((prevState) => {
                        return { entity: { ...prevState.entity, nationalCode: e.target.value } }
                    })}>
                    </input>
                </>;
                break;
            case 3:
                contentBody = (
                    <input className="form-control" inputMode="numeric" placeholder="کد امنیتی " value={entity.otp} onChange={e => this.setState((prevState) => {
                        return { entity: { ...prevState.entity, otp: e.target.value } }
                    })}>
                    </input>);
                break;
            default:
                break;
        }

        if (entity.haveOTP && step === RegisterSteps.otpCode) {

            submitButton = (<div className="col-12 notspace" style={{ paddingTop: "10px" }}>
                <button type="button" onClick={this.getRegisterPage} className="btn btn-block btn-primary">تایید کد</button>
            </div >);
        }
        else {

            submitButton = (<div className="col-12 notspace">
                <button type="submit" onClick={() => this.changeStep(+1)} className="btn btn-block btn-primary mt-3">ادامه</button>
            </div>);
        }

        return (<>
            {this.state.showNavigator && <Navigate to={"/Login"} />}
            <label onClick={() => this.changeStep(-1)} className="mdi mdi-arrow-left register-area navigator-icon" ></label>

            <div className="register-area">
                <label className="title">ثبت نام موقت</label>
                {contentBody}
                {submitButton}
            </div>
        </>);
    }
} 